<template>
    <div class="footer-body">
        <v-container>
            <v-row v-bind="{ ...bodyRowAttrs }" :class="bodyRowAttrs?.className">
                <v-col v-if="this.$slots['default']" v-bind="{ ...bodyDefaultAttrs }" :class="bodyDefaultAttrs?.className">
                    <slot />
                </v-col>
                <v-col v-if="this.$slots['left']" v-bind="{ ...bodyLeftAttrs }" :class="bodyLeftAttrs?.className">
                    <slot name="left" />
                </v-col>
                <v-col v-if="this.$slots['center']" v-bind="{ ...bodyCenterAttrs }" :class="bodyCenterAttrs?.className">
                    <slot name="center" />
                </v-col>
                <v-col v-if="this.$slots['right']" v-bind="{ ...bodyRightAttrs }" :class="bodyRightAttrs?.className">
                    <slot name="right" />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    props: {
        bodyRowAttrs: { type: Object, default: () => ({}) },
        bodyDefaultAttrs: { type: Object, default: () => ({}) },
        bodyLeftAttrs: { type: Object, default: () => ({}) },
        bodyCenterAttrs: { type: Object, default: () => ({}) },
        bodyRightAttrs: { type: Object, default: () => ({}) },
    },
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
